var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9466 11.1938C17.3118 14.9599 13.948 17.6473 10.1347 17.4348C6.32141 17.2224 3.27697 14.1779 3.0645 10.3646C2.85203 6.55133 5.53941 3.18752 9.3055 2.55273",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5823 7.33203C17.7467 7.77354 17.8687 8.22967 17.9467 8.69427",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3375 5.16267C16.0367 4.79855 15.702 4.46385 15.3379 4.16309",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1689 2.91778C12.7274 2.75306 12.2713 2.63079 11.8066 2.55262",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8345 10.3264H10.1738V5.83203",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftImage);
export default __webpack_public_path__ + "static/media/left-image.a3bc43e940dd6a7fda4978c5d84b2e66.svg";
export { ForwardRef as ReactComponent };